// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3Q-BM","modalFooterButton":"ModalNotes_modalFooterButton__2o_LW"};